import { pipe } from "fp-ts/lib/function";

import { Ord, RA, RNEA, s } from "@scripts/fp-ts";
import type { MediaCategoryU } from "@scripts/generated/domaintables/mediaCategories";
import { allReports, officialStmts, plom, pos } from "@scripts/generated/domaintables/mediaCategories";
import type { SelectOption } from "@scripts/react/components/form/Select";

const mediaCategoryAlphabeticalOrd = Ord.contramap((category: MediaCategoryU) => category.categoryName)(s.Ord);

export const offeringDocumentCategories = [pos, officialStmts, plom];

export const baseDocumentCategories: RNEA.ReadonlyNonEmptyArray<MediaCategoryU> = allReports;

export const documentCategorySelectOptions = pipe(
  RNEA.sort(mediaCategoryAlphabeticalOrd)(baseDocumentCategories),
  RA.map((category): SelectOption<number> => ({
    value: category.id,
    label: category.categoryName,
  }))
);
